import { createSelector } from 'reselect';
import isEmpty from 'lodash.isempty';

import { getFilterParamsAdapter, getTimeFilterParams } from './../../api-adapter';
import { getInterval, formatDuration, prepareOwnersQueryV2, isOrganizationScopeEnabled } from '../../util';
import { eventMetaDataSelector } from '../common/tracking/selectors';
import { TRACKING_SUB_AREA } from '../../trackingV2';
import { CONCURRENCY_FILTERS_MAP } from '../filters/constants';

const filters = (store) => store.apps.analytics.filters;
const activityStore = (store) => store.apps.analytics.activity;
const userStore = (store) => store.user;
const ownersStore = (store) => store.apps.analytics.owners;
const generalStore = (store) => store.apps.analytics.generalReducer;

export const concurrencySelector = createSelector([
  filters,
  eventMetaDataSelector,
], (filteredFilters, eventMetaData) => ({
  filters: filteredFilters.get('filters'),
  selectedDateFilter: filteredFilters.get('selectedDateFilter'),
  eventMetaData: {
    ...eventMetaData,
    product_sub_area: TRACKING_SUB_AREA.CONCURRENCY,
  },
}));

export const activitySelector = createSelector([
  filters,
  activityStore,
  generalStore,
], (filteredFilters, activity, general) => ({
  loading: general.get('loading'),
  filters: filteredFilters.get('filters'),
  selectedDateFilter: filteredFilters.get('selectedDateFilter'),
  selectedDays: formatDuration(filteredFilters.get('selectedDateFilter')),
  loadingActivity: activity.get('loading'),
  loadingUsersActivity: activity.get('loadingUsersActivity'),
  activity: activity.get('activity'),
}));

export const activityParamsSelector = createSelector([
  filters,
  userStore,
  ownersStore,
  (store, options = {}) => options,
], (filtersStore, user, owners, options) => {
  const timeParam = getTimeFilterParams(filtersStore.get('selectedDateFilter'), options.base);

  return {
    ...getFilterParamsAdapter(filtersStore.get('filters')),
    ...timeParam,
    user,
    owners: owners.get('owners'),
    interval: getInterval(timeParam.end - timeParam.start),
    dateFilterType: filtersStore.getIn(['selectedDateFilter', 'type']),
  };
});

export const filterConcurrencyParamsSelector = createSelector([
  filters,
  userStore,
  (store, options = {}) => options,
], (filtersStore, user, options) => {
  const timeParams = getTimeFilterParams(filtersStore.get('selectedDateFilter'), options.base);
  const ownersParams = prepareOwnersQueryV2(filtersStore.getIn(['filters', 'owners', 'selectedItems']));
  const usedFilters = filtersStore.get('filters').filter((value, key) => CONCURRENCY_FILTERS_MAP.has(key));

  return {
    ...getFilterParamsAdapter(usedFilters),
    ...ownersParams,
    ...timeParams,
    org_id: user.organization.id,
    ...(isEmpty(ownersParams) && !isOrganizationScopeEnabled(user) ?
      { team_id: user.getUserTeamId() } : {}),
    interval: getInterval(timeParams.end - timeParams.start),
  };
});

export default activitySelector;
